import { decodePoolCandidate } from '@/models/Company/Candidate';
import { ServerApi } from '@/modules/api/server-api';

export const fetchVacancyCandidates = (api: ServerApi) => async (
  vacancyId: string | number,
  status: string,
  page: number,
) => {
  const response = await api.get(
    `/v3/company/vacancies/${vacancyId}/candidates?status=${status}&page=${page}&per_page=20`,
  );
  const candidates = response.data.candidates.map(decodePoolCandidate);
  const { total, counters } = response.data;
  return { candidates, total, counters };
};
